import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CompliancePieChart = ({ aTiempo, retrasos }) => {
  // Lógica para calcular los tamaños de las rebanadas del gráfico de pastel
  const total = aTiempo + retrasos;
  const cumplidoPercentage = (aTiempo / total) * 100;
  const noCumplidoPercentage = (retrasos / total) * 100;

  // Datos para el gráfico de pastel
  const data = [
    { name: 'Cumplido', value: cumplidoPercentage, count: aTiempo },
    { name: 'No Cumplido', value: noCumplidoPercentage, count: retrasos },
  ];

  const COLORS = ['#FFC700', '#76A140']; // Verde para cumplido, rojo para no cumplido

  return (
    <div className="justify-center bg-white shadow-[0px_5px_20px_rgba(0,0,0,0.3)] rounded-[16px] space-x-11 mb-10">
      <div className="w-full p-6">
        <div className="flex items-center">
          <p className="text-[20px] font-itcmedium text-[#007696] w-[50%]">
            Porcentaje de cumplimiento
          </p>
            <div className='flex w-[50%] space-x-9 2xl:ml-[33rem]'>
                <button className="sm:px-[10px]  px-[35px]  h-[46px] text-[14px] text-center bg-[#5CBDEB] border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
                    Filtrar por empresa
                </button> 
                <button className="sm:px-[10px]  px-[35px]  w-[151px] h-[46px] text-[14px] text-center bg-white border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
                    Filtrar por placa
                </button> 
            </div>   
        </div>
        <div className="flex">
            <div className="justify-center w-[50%]">
                <div className="w-64 h-64 relative 2xl:ml-80">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={30}
                                outerRadius={90}
                                fill="#8884d8"
                                paddingAngle={5}
                            >
                                {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value, name) => `${value.toFixed(2)}%`} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            <div className="flex w-[50%] items-center space-x-12">
                <div>
                    <h3 className="text-[16px] font-itcmedium">TASA</h3>
                    <p className='text-[22px]  font-itcmedium '>1,026</p>
                    <p className='text-[12px]  font-itcmedium text-[#52526CCC] mb-4'>Vehículos pesados</p>
                    <div className='bg-[#F2F3F7] border-[0.5px] border-[#D9D9D9] rounded-[5px] p-3'>
                        <div className='flex items-center'>
                            <div className="w-[5px] h-[5px] rounded-full mr-2" style={{ backgroundColor: COLORS[0] }}></div>
                            <h3 className="text-[16px] text-[#FFC700] font-itcmedium">Cumplido</h3>
                        </div> 
                        <p className="text-[12px] text-[#52526CCC] font-itcmedium">{`${aTiempo} a tiempo (${cumplidoPercentage.toFixed(0)}%)`}</p>
                    </div>
                    
                </div>
                <div>
                    <h3 className="text-[16px] font-itcmedium">GLOBAL SAC</h3>
                    <p className='text-[22px]  font-itcmedium '>1,326</p>
                    <p className='text-[12px]  font-itcmedium text-[#52526CCC]  mb-4'>Vehículos pesados</p>

                    <div className='bg-[#F2F3F7] border-[0.5px] border-[#D9D9D9] rounded-[5px] p-3'>
                        <div className='flex items-center'>
                            <div className="w-[5px] h-[5px] rounded-full mr-2" style={{ backgroundColor: COLORS[1] }}></div>
                            <h3 className="text-[16px] text-[#76A140] font-itcmedium">No Cumplido</h3>
                        </div>
                        <p className="text-[12px] text-[#52526CCC] font-itcmedium">{`${retrasos} retrasos (${noCumplidoPercentage.toFixed(0)}%)`}</p>
                        
                    </div>               
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

const ExampleComplianceData = () => {
  const aTiempo = 24; 
  const retrasos = 36; 

  return <CompliancePieChart aTiempo={aTiempo} retrasos={retrasos} />;
};

export default ExampleComplianceData;
